import React from 'react'

import { type CustomerAttributeGroup } from '~/hooks/useSurveyQuery'
import { pathAssume } from '~/utils'

import { useCustomerAttributesData } from '../hooks/useCustomerAttributesData'

import { IndividualTable, type IndividualTableProps } from './IndividualTable'

export type IndividualCustomerAttributeTableProps = {
  customerAttributeGroup: CustomerAttributeGroup
}

export const IndividualCustomerAttributeTable = ({
  customerAttributeGroup,
}: IndividualCustomerAttributeTableProps) => {
  const customerAttributesData = useCustomerAttributesData(
    customerAttributeGroup,
  )
  const individualTableProps = React.useMemo<
    IndividualTableProps<(typeof customerAttributesData)[number]>
  >(
    () => ({
      getAnswerText: pathAssume('customerAttribute.name'),
      getLabel: pathAssume('0.customerAttributeGroup.name'),
      getRowId: pathAssume('customerAttribute.id'),
      getSubLabel: pathAssume('customerAttribute.name'),
      id: customerAttributeGroup.id,
      rowsData: customerAttributesData,
    }),
    [customerAttributeGroup.id, customerAttributesData],
  )

  return <IndividualTable {...individualTableProps} />
}
